import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, Popconfirm } from 'antd';
import cx from 'classnames';
import styles from './styles.module.scss';
const MenuDeleteButton = props => {
  const {
    onConfirm
  } = props;
  return <Menu.Item key="1">
      <Popconfirm title="Are you sure you want to delete this project?" onConfirm={onConfirm} okText="Yes" cancelText="No" className={cx('confirmDelete', styles.popConfirm)}>
        <span className={styles.deleteButton}>
          <FontAwesomeIcon className={styles.deleteIcon} icon={faTrash} />{' '}
          Delete Project
        </span>
      </Popconfirm>
    </Menu.Item>;
};
export default MenuDeleteButton;